/* AgroLux JS — minimal, conversion-focused */
(function () {
  'use strict';

  var reduceMotion = false;
  try {
    reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  function initStickyATC() {
    var bar = document.querySelector('.agx-sticky-atc');
    if (!bar) return;

    var mainBtn = document.querySelector('.product-form__submit');
    if (!mainBtn) return;

    function setVisible(v) {
      bar.classList.toggle('is-visible', !!v);
      bar.setAttribute('aria-hidden', v ? 'false' : 'true');
    }

    setVisible(false);

    bar.addEventListener('click', function (e) {
      var target = e.target.closest('[data-agx-atc]');
      if (!target) return;
      e.preventDefault();
      mainBtn.click();
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          var entry = entries && entries[0];
          if (!entry) return;
          setVisible(!entry.isIntersecting);
        },
        { threshold: 0.35 }
      );
      io.observe(mainBtn);
    } else {
      window.addEventListener(
        'scroll',
        function () {
          var r = mainBtn.getBoundingClientRect();
          var inView = r.top < window.innerHeight && r.bottom > 0;
          setVisible(!inView);
        },
        { passive: true }
      );
    }
  }

  function initPressedFX() {
    if (reduceMotion) return;
    document.addEventListener(
      'pointerdown',
      function (e) {
        var btn = e.target.closest('.button, .shopify-payment-button__button');
        if (!btn) return;
        btn.classList.add('is-pressed');
      },
      { passive: true }
    );
    document.addEventListener(
      'pointerup',
      function (e) {
        var btn = e.target.closest('.button, .shopify-payment-button__button');
        if (!btn) return;
        btn.classList.remove('is-pressed');
      },
      { passive: true }
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    initStickyATC();
    initPressedFX();
  });
})();
